export default [
  {
    path: '/user/:userAlias',
    name: 'profile-overview',
    component: () => import('./pages/page-profile-overview.vue')
  },
  {
    path: '/user/:userAlias/projects',
    name: 'profile-projects',
    component: () => import('./pages/page-profile-projects.vue')
  },
  {
    path: '/user/:userAlias/subscriptions',
    name: 'profile-subscriptions',
    component: () => import('./pages/page-profile-subscriptions.vue')
  },
  {
    path: '/user/:userAlias/followers',
    name: 'profile-followers',
    component: () => import('./pages/page-profile-followers.vue')
  },
  {
    path: '/user/:userAlias/favorites',
    name: 'profile-favorites',
    component: () => import('./pages/page-profile-favorites.vue')
  }
];
